import React from 'react';
import { useScript } from 'hooks/useScript';

const PARSELY_API_KEY = process.env.NEXT_PUBLIC_PARSELY_API_KEY;

if (!PARSELY_API_KEY) {
  throw new Error('NEXT_PUBLIC_PARSELY_API_KEY not set');
}

export const ParselyScript = () => {
  const containerRef = React.useRef<null | HTMLDivElement>(null);
  /**
   * Injecting Parse.ly script using our custom hook was the only way to get it working as it should,
   * as rendering the script the old way was not setting up the cookies.
   */
  useScript(
    `//cdn.parsely.com/keys/${PARSELY_API_KEY}/p.js`,
    containerRef,
    'parsely-cfg',
  );

  return <div ref={containerRef} />;
};
